import styled from '@emotion/styled'

export const StyledDetailContainer = styled.div`
  padding: 24px;
  border-top: 1px solid #f0f0f0;

  @media (max-width: 480px) {
    padding: 16px;
  }
`

export const StyledFieldsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const StyledFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const StyledLabel = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
`

export const StyledLabelWithIcon = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
`

export const StyledReadOnlyField = styled.div`
  padding: 12px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  color: #102638;
`

export const StyledReadOnlyFieldSmall = styled.div`
  flex: 1;
  min-width: 0;
  padding: 12px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  color: #102638;
`

export const StyledInput = styled.input`
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  color: #102638;
  transition: border-color 0.15s ease-out;

  &:focus {
    outline: none;
    border-color: #a855f7;
  }

  &::placeholder {
    color: #9ca3af;
  }
`

export const StyledInputSmall = styled(StyledInput)`
  flex: 1;
  min-width: 0;
`

export const StyledSelect = styled.select`
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  color: #102638;
  cursor: pointer;
  transition: border-color 0.15s ease-out;

  &:focus {
    outline: none;
    border-color: #a855f7;
  }
`

export const StyledAddressRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`

export const StyledTwoColumnRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const StyledDivider = styled.hr`
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 24px 0;
`

export const StyledMembersSection = styled.div``

export const StyledMembersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const StyledMembersTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #102638;
  margin: 0;
`

export const StyledInviteButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: #a855f7;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: background-color 0.15s ease-out;

  &:hover:not(:disabled) {
    background: #9333ea;
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }
`

export const StyledMemberGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
`

export const StyledButtonRow = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;

  @media (max-width: 480px) {
    justify-content: stretch;
  }
`

export const StyledUpdateButton = styled.button`
  background: #1e3a5f;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease-out;

  &:hover:not(:disabled) {
    background: #2d4a6f;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`

export const StyledLogoUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledLogoUploadContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const StyledLogoPreview = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 10px;
  overflow: hidden;
  background: #f9fafb;
  border: 1px solid #e5e7eb;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const StyledPlaceholderLogo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #a855f7 0%, #ec4899 100%);
  color: white;
`

export const StyledLogoActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledUploadLabel = styled.label<{ isUploading: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  background: #1e3a5f;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: ${props => (props.isUploading ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.isUploading ? 0.7 : 1)};
  transition: background-color 0.15s ease-out;

  &:hover {
    background: ${props => (props.isUploading ? '#1e3a5f' : '#2d4a6f')};
  }

  input {
    display: none;
  }
`

export const StyledRemoveLogoButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  color: #dc2626;
  border: 1px solid #dc2626;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.15s ease-out;

  &:hover {
    background: #fef2f2;
  }
`

export const StyledReadOnlyLogoPreview = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 10px;
  overflow: hidden;
  background: #f9fafb;
  border: 1px solid #e5e7eb;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const StyledLeaveSection = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const StyledLeaveButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  color: #dc2626;
  border: 1px solid #dc2626;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-out;

  &:hover:not(:disabled) {
    background: #fef2f2;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`

export const StyledTransferSection = styled.div``

export const StyledTransferHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`

export const StyledTransferTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
`

export const StyledTransferToggleButton = styled.button`
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-out;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #9ca3af;
  }

  &:disabled {
    background: #f3f4f6;
    color: #9ca3af;
    cursor: not-allowed;
  }
`

export const StyledTransferNote = styled.p`
  font-size: 13px;
  color: #9ca3af;
  margin: 8px 0 0 0;
`

export const StyledTransferForm = styled.div`
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  padding: 16px;
`

export const StyledTransferDescription = styled.p`
  font-size: 13px;
  color: #92400e;
  margin: 0 0 12px 0;
`

export const StyledTransferSelect = styled.select`
  width: 100%;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #102638;
  cursor: pointer;
  margin-bottom: 12px;

  &:focus {
    outline: none;
    border-color: #f59e0b;
  }
`

export const StyledTransferButtonRow = styled.div`
  display: flex;
  gap: 12px;
`

export const StyledTransferConfirmButton = styled.button`
  background: #f59e0b;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease-out;

  &:hover:not(:disabled) {
    background: #d97706;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`

export const StyledTransferCancelButton = styled.button`
  background: transparent;
  color: #6b7280;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-out;

  &:hover {
    background: #f9fafb;
  }
`

export const StyledDeleteSection = styled.div``

export const StyledDeleteHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`

export const StyledDeleteTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #dc2626;
  margin: 0;
`

export const StyledDeleteDescription = styled.p`
  font-size: 13px;
  color: #9ca3af;
  margin: 8px 0 0 0;
`

export const StyledDeleteWarning = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 13px;
  color: #991b1b;
  margin-top: 12px;
`

export const StyledDeleteButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  color: #dc2626;
  border: 1px solid #fecaca;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-out;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    background: #fef2f2;
    border-color: #dc2626;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`

export const ORGANIZATION_TYPE_OPTIONS = [
  { value: '', label: 'Select type...' },
  { value: 'non_profit', label: 'Non-Profit' },
  { value: 'business', label: 'Business' },
]

export const ORGANIZATION_TYPE_LABELS: Record<string, string> = {
  non_profit: 'Non-Profit',
  business: 'Business',
}
